import { QueryClient, DefaultOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

function shouldRetry(failureCount: number, error: Error): boolean {
  const MAX_RETRIES = 3;

  if (failureCount >= MAX_RETRIES) {
    return false;
  }

  if ((error as AxiosError).isAxiosError) {
    const axiosError = error as AxiosError;
    const status = axiosError.response?.status;

    if (
      status &&
      status >= 400 &&
      status < 500 &&
      status !== 408 &&
      status !== 429
    ) {
      return false;
    }
  }

  return true;
}

const defaultQueryOptions: DefaultOptions = {
  queries: {
    retry: shouldRetry,
    retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
    refetchOnMount: true,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true
  },
  mutations: {
    retry: false
  }
};

export const queryClient = new QueryClient({
  defaultOptions: defaultQueryOptions
});
